export const wordExts = [
  "doc",
  "docm",
  "docx",
  "dot",
  "dotm",
  "dotx",
  "epub",
  "fb2",
  "fodt",
  "htm",
  "html",
  "hwp",
  "hwpx",
  "md",
  "mht",
  "mhtml",
  "odt",
  "ott",
  "pages",
  "rtf",
  "stw",
  "sxw",
  "txt",
  "wps",
  "wpt",
  "xml",
];
export const cellExts = [
  "csv",
  "et",
  "ett",
  "fods",
  "numbers",
  "ods",
  "ots",
  "sxc",
  "xls",
  "xlsm",
  "xlsx",
  "xlt",
  "xltm",
  "xltx",
];
export const slideExts = [
  "dps",
  "dpt",
  "fodp",
  "key",
  "odg",
  "odp",
  "otp",
  "pot",
  "potm",
  "potx",
  "pps",
  "ppsm",
  "ppsx",
  "ppt",
  "pptm",
  "pptx",
  "sxi",
];
export const pdfExts = ["djvu", "docxf", "oform", "oxps", "pdf", "xps"];
export const diagramExts = ["vsdm", "vsdx", "vssm", "vssx", "vstm", "vstx"];
